// extracted by mini-css-extract-plugin
export default {"main":"NLeftPart_main__PCeRP","title":"NLeftPart_title__-Yt6T","left":"NLeftPart_left__o-I+F","right":"NLeftPart_right__K6VZ7","info":"NLeftPart_info__mxAeG"};